import { Crown, ShieldCheck, FileText, Coins } from 'lucide-react';

const TIER_CFG = {
  king: {
    label: 'King',
    Icon: Crown,
    cls: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-950/40 dark:text-yellow-400 border border-yellow-300/40 dark:border-yellow-700/40',
  },
  aristocrat: {
    label: 'Aristocrat',
    Icon: ShieldCheck,
    cls: 'bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400 border border-amber-300/40 dark:border-amber-700/40',
  },
  analyst: {
    label: 'Analyst',
    Icon: FileText,
    cls: 'bg-sky-100 text-sky-700 dark:bg-sky-950/40 dark:text-sky-400 border border-sky-300/40 dark:border-sky-700/40',
  },
  novice: {
    label: 'Novice',
    Icon: Coins,
    cls: 'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400 border border-zinc-300/40 dark:border-zinc-700/40',
  },
};

export default function TierBadge({ tier = 'novice', size = 'sm', showLabel = true }) {
  const c = TIER_CFG[tier] || TIER_CFG.novice;
  const sizeCls = size === 'lg'
    ? 'px-2.5 py-1 text-xs'
    : 'px-2 py-0.5 text-[10px]';
  const iconSize = size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wide ${c.cls} ${sizeCls}`}
      data-testid={`tier-badge-${tier}`}
      title={`${c.label} tier`}
    >
      <c.Icon className={iconSize} />
      {showLabel ? c.label : null}
    </span>
  );
}
